import FilterModalComponent from './component';

export default class FilterModalRoute extends FilterModalComponent {
}
